import * as React from 'react';
import PopupButtons from './PopupButtons';
import PartyEditor from './parties/PartyEditor';
import { Button } from '@symphony-ui/uitoolkit-components';
const PartiesPopup = ({ data, save }) => {
    const [parties, setParties] = React.useState(data?.meta?.parties?.map(p => ({
        companyId: p.companyId, name: p.name, type: p.type
    })) ?? [undefined]);
    const onChangeParty = React.useCallback((index) => (event) => {
        setParties(current => {
            const clone = [...current];
            clone[index] = event.target.value;
            return clone;
        });
    }, []);
    const onClickAdd = React.useCallback(() => {
        setParties(current => {
            const clone = [...current];
            clone.push(undefined);
            return clone;
        });
    }, []);
    const remove = React.useCallback((index) => () => {
        setParties(current => {
            const clone = [...current];
            clone.splice(index, 1);
            if (clone.length === 0) {
                clone.push(undefined);
            }
            return clone;
        });
    }, []);
    const liveParties = React.useMemo(() => parties.filter(p => p !== undefined), [parties]);
    const isDisabledAdd = React.useMemo(() => parties.some(p => p === undefined), [parties]);
    const isDisabledSave = React.useMemo(() => parties.length === 0 || parties.some(p => p === undefined), [parties]);
    return (React.createElement("div", { className: 'co-dropdown-abaolute' },
        parties.map((p, index) => (React.createElement(PartyEditor, { key: (p?.companyId ?? index.toString()) + "-" + (p?.type ?? index.toString()), value: p, onChange: onChangeParty(index), remove: remove(index) }))),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(Button, { disabled: isDisabledAdd, onClick: onClickAdd, size: "small" }, "ADD"),
            React.createElement(PopupButtons, { value: liveParties, hasOverride: false, save: save, isDisabled: isDisabledSave }))));
};
export default PartiesPopup;
